import { render } from "./PortfolioModalOne.vue?vue&type=template&id=4fc5bd2c"
import script from "./PortfolioModalOne.vue?vue&type=script&lang=js"
export * from "./PortfolioModalOne.vue?vue&type=script&lang=js"
script.render = render

export default script